import { map } from 'rxjs';
import { memo } from '../util/index.js';
/**
 * @description Get the member info for a society
 */
export function member(instanceId, api) {
    return memo(instanceId, (accountId) => api.derive.society._members([accountId]).pipe(map(([result]) => result)));
}
